export const plotPoints = (
  radius: number,
  numberOfPoints: number,
  xPosition: number,
  yPosition: number,
): Array<{ x: number; y: number }> => {
  const angleStep = (Math.PI * 2) / numberOfPoints;
  const points = [];

  for (let i = 1; i <= numberOfPoints; i++) {
    const x = xPosition + Math.sin(i * angleStep) * radius;
    const y = yPosition + Math.cos(i * angleStep) * radius;

    points.push({ x, y });
  }

  return points;
};
